import { render, staticRenderFns } from "./delete-account-confirm.vue?vue&type=template&id=29cfcf74&scoped=true"
import script from "./delete-account-confirm.vue?vue&type=script&lang=js"
export * from "./delete-account-confirm.vue?vue&type=script&lang=js"
import style0 from "./delete-account-confirm.vue?vue&type=style&index=0&id=29cfcf74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cfcf74",
  null
  
)

export default component.exports